import axios from "axios";
import ApiInterceptor from "../ApiInterceptor";
import { config } from "../../../constant";
import { toast } from "react-hot-toast";
// import apiInterceptor from "../ApiInterceptor";

const API_BASE_URL = config?.url?.API_URL;
const GOOGLE_API_URL = config?.url?.GOOGLE_API_URL;
const GOOGLE_API_KEY = config?.url?.GOOGLE_API_KEY;
const API_BASE_CRM_URL = config?.url?.CRM_API_URL;
// Register'
console.log(API_BASE_URL);
export const registerUser = (userData) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + "register-user", userData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success("Verify your email.");
        }
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response?.data?.statusCode == 400) {
          toast.error(error.response?.data?.message);
        }
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const registerCrmUser = (userData) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_CRM_URL + "User", userData, {
        headers: {
          // "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: "Basic YWRtaW46RXNwb1VzZXJQYXNzMTIzIQ==",
        },
      })
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success("Verify your email.");
        }
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response?.data?.statusCode == 400) {
          toast.error(error.response?.data?.message);
        }
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
// login
export const loginUser = (userData) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + "login", userData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response?.data?.status_code == 200) {
          const token = response?.data?.data?.access_token;
          localStorage.setItem("token", token);
          toast.success("Login successfully");
        }

        resolve(response?.data);
      })

      .catch((error) => {
        reject(error);
        if (error.response) {
          if (error?.response?.data?.detail?.status_code == 401) {
            toast.error(error?.response?.data?.detail?.message);
            reject(error.response.data);
          }
          reject(error.response.data);
        } else if (error.request) {
          toast.error("Internal server error.");
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// google login
export const googleLoginUser = (userData) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    console.log(userData);

    formData.append("token", userData);
    axios
      .post(API_BASE_URL + "google-login", formData, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response?.data?.status_code == 200) {
          const token = response?.data?.data?.access_token;
          localStorage.setItem("token", token);
          localStorage.setItem(
            "common_id",
            response?.data?.data?.restaurant_details[0].common_id
          );
          localStorage.setItem(
            "business_name",
            response?.data?.data?.restaurant_details[0].restaurant_name
          );
          toast.success("Login successfully");
        }

        resolve(response?.data);
      })

      .catch((error) => {
        reject(error);
        if (error.response) {
          if (error?.response?.data?.detail?.status_code == 401) {
            toast.error(error?.response?.data?.detail?.message);
            reject(error.response.data);
          }
          reject(error.response.data);
        } else if (error.request) {
          toast.error("Internal server error.");
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// Verify email
export const verifyEmail = (userData) => {
  return new Promise((resolve, reject) => {
    axios
      .get(API_BASE_URL + `verify?email=${userData}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// Verify email
export const verifyEmailLanding = (userData) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        API_BASE_URL +
          `verify?email=${userData.email}&password=${userData.password}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const resendVerifyEmail = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `resend-verification-email`, payload, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response.data);
      })

      .catch((error) => {
        toast.error(error?.response?.data?.detail);
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
// updateProfile
export const updateProfile = (userData) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.put(API_BASE_URL + `update-profile`, userData)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response.data);
      })

      .catch((error) => {
        toast.error(error?.response?.data?.detail);
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// get user profile
export const getProfile = () => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(API_BASE_URL + `get-profile`, config)
      .then((response) => {
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// deleteUser
export const deleteUser = (userData) => {
  let config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    data: userData,
  };

  return new Promise((resolve, reject) => {
    ApiInterceptor.delete(API_BASE_URL + "delete_user", config)
      .then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success("Your account has been successfully deleted.");
          setTimeout(() => {
            localStorage.removeItem("token");

            // Clear all cookies
            document.cookie.split(";").forEach((c) => {
              document.cookie = c
                .replace(/^ +/, "")
                .replace(
                  /=.*/,
                  "=;expires=" + new Date().toUTCString() + ";path=/"
                );
            });

            window.location.href = "/sign-in";
          }, 500);
        }
        resolve(response.data);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// forgot-password
export const forgotPassword = (payload) => {
  return new Promise((resolve, reject) => {
    let config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    axios
      .post(API_BASE_URL + `forgot-password`, payload, config)
      .then((response) => {
        if (response.data.statusCode == 200) {
          toast.success(response.data.message);
        } else {
          toast.error(response?.data?.message);
        }
        resolve(response.data);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// reset password
export const resetPassword = ({ payload, config }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `reset-password`, payload, config)
      .then((response) => {
        if (response?.data?.statusCode == 200) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        resolve(response);
      })

      .catch((error) => {
        toast.error(error?.response?.data?.message);
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// update busniess-links
export const updateBusinessPages = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.put(API_BASE_URL + `update-business-pages`, payload)
      .then((response) => {
        if (response?.data?.statusCode == 200) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        resolve(response);
      })

      .catch((error) => {
        toast.error(error?.response?.data?.message);
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getAllRestaurants = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(API_BASE_URL + `restaurants/`)
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const GoogleSearch = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        GOOGLE_API_URL + `geocode/json?address=${payload}&key=${GOOGLE_API_KEY}`
      )
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const GoogleSearchNearByAddress = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `https://nominatim.openstreetmap.org/search?q=${payload}&format=json`
      )
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const scrapeUrl = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get_links`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const scrapeAll = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `scrapping_reviews`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const updateSrapping = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `update_scrapping_reviews`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const updateAll = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `update_scrapping_reviews`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addBusiness = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `google_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const addFacebookReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `facebook_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addYelpReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `yelp_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addTwitterReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `twitter_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// get all business on the basis of user
export const getMyBusiness = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get-businesses`, payload)
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const getRequestReviewCount = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `review-request-stats`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const getGenericReviewRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get-generic-review-request`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const getRequestReview = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get-review-requests`, payload)
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const getSingleBusiness = (params) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(API_BASE_URL + `business/${params}`)
      .then((response) => {
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const editBusiness = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.put(API_BASE_URL + `update-business`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const editRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get-review-request-by-id`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const updateReviewRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `update-review-request`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const googleToken = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `auth_scrapping_reviews`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addUpdatedGoogleReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `twitter_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addUpdatedfacebookReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `twitter_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addUpdatedYelpReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `twitter_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const addUpdatedTwitterReviews = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `twitter_scrape`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const removeBusiness = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.put(API_BASE_URL + `delete_business`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const facebookToken = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(
      API_BASE_URL + `get_facebook_access_token/?authorization_code=${payload}`
    )
      .then((response) => {
        if (response?.data?.status_code == 200) {
          // toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getFbData = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `auth_scrapping_facebook`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getBusinessIntelligence = (business_id) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(
      API_BASE_URL + `chatbot/business/${business_id}/intelligence`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const getLocalIntelligence = (business_id) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(
      API_BASE_URL + `chatbot/business/${business_id}/local_intelligence`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getBusinessSummary = (business_id) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(API_BASE_URL + `chatbot/business/${business_id}/summary`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getBusinessInsights = (business_id) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.get(
      API_BASE_URL + `chatbot/business/${business_id}/insights`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const createReview = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `add-review-request`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const sendRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `send-review-request`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const deleteRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.delete(
      API_BASE_URL + `delete-review-request` + `/${payload}`
    )
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response deleted");
        } else {
          reject(error.message);
        }
      });
  });
};

export const cancelRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `reset-review-request`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const GenericRequestByLink = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(
      API_BASE_URL + `get-generic-review-request-by-link`,
      payload
    )
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const RequestByLink = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `get-review-request-by-link`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const genericRequest = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `generic-request-scan`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};
export const markReview = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(API_BASE_URL + `mark-review-request-done`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

//Google OwnwerShip
export const googleOwnerShip = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(
      API_BASE_URL + `check_google_business_ownership`,
      payload
    )
      .then((response) => {
        if (response?.status_code == 200) {
          toast.success(response?.data?.reason);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

//FaceBook OwnwerShip
export const facebookOwnerShip = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.post(
      API_BASE_URL + `check_facebook_business_ownership`,
      payload
    )
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// Update business address links
export const updateBusinessAddress = (payload) => {
  return new Promise((resolve, reject) => {
    ApiInterceptor.put(API_BASE_URL + `update-business-address`, payload)
      .then((response) => {
        if (response?.data?.status === "success") {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        resolve(response);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Update failed");
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

//chatbot compare me
export const compareMe = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `chatbot/compare-me`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

//chatbot compare me
export const RAmoments = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `chatbot/ra-moments-suggestion`, payload)
      .then((response) => {
        if (response?.data?.status_code == 201) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const RequestADemo = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `request-a-demo`, payload)
      .then((response) => {
        if (response?.data?.status_code == 200) {
          toast.success(response?.data?.message);
        }
        resolve(response);
      })

      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getMoment = (username, { maxSize = 5, offset = 3 } = {}) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .get(API_BASE_CRM_URL + `CMoment`, {
        headers,
        params: {
          maxSize,
          offset,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getOffers = (username) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .get(API_BASE_CRM_URL + `COffer`, { headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const sendEmail = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `crm/send-email-to-all`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const sendMomentEmail = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `crm/send-moment-email`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getRequestReviewList = (
  username,
  { maxSize = 5, offset = 3 } = {}
) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .get(API_BASE_CRM_URL + `CRequestReviewList`, {
        headers,
        params: {
          maxSize,
          offset,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getReviewRequestByID = (username, contact_id) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .get(API_BASE_URL + `crm/review-request/${contact_id}`, { headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const editReviewRequestByID = (username, request_id, formDataObject) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
      "Content-Type": "application/json",
    };
    axios
      .put(
        `${API_BASE_CRM_URL}CRequestReviewList/${request_id}`,
        formDataObject,
        { headers }
      )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

//Delete Review Request By ID
export const deleteReviewRequestByID = (username, deletedId) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .delete(API_BASE_CRM_URL + `CRequestReviewList/${deletedId}`, { headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const sendReviewRequest = (payload) => {
  return new Promise((resolve, reject) => {
    // const authtoken = btoa(`${username}:${username}`);

    axios
      .post(API_BASE_URL + `crm/send-review-request`, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

// Mark Review Request Done
export const markReviewRequestDone = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API_BASE_URL + `crm/mark-review-request-done`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const updateMomentStatus = (payload, id, username) => {
  return new Promise((resolve, reject) => {
    const authtoken = btoa(`${username}:${username}`);
    const headers = {
      Authorization: `Basic ${authtoken}`,
    };
    axios
      .put(API_BASE_CRM_URL + `CMoment/${id}`, payload, { headers })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const getReviewRequestByIdCrm = (formData) => {
  return new Promise((resolve, reject) => {
    axios.post(API_BASE_URL + `get-review-request-by-id-crm`, formData, {
        headers: {
          // Axios will automatically set the 'Content-Type' to 'multipart/form-data' when sending FormData
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};

export const assignBusinesstocrm = (payload) => {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem('token') ? localStorage.getItem('token') : "";
    axios.post(API_BASE_URL + `assign-business-to-crm`, payload,{
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};


// User
export const fetchUser = (username) => {
  return new Promise((resolve, reject) => {
    const authToken = btoa(`${username}:${username}`);

    axios.get(API_BASE_CRM_URL + `User`,{
        headers: {
          "Authorization": `Basic ${authToken}`,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response.data);
        } else if (error.request) {
          reject("No response received");
        } else {
          reject(error.message);
        }
      });
  });
};